<template>
  <section
    v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row justify-between items-center">
        <div class="col-auto">
          <div v-html="vars.titleHtml"></div>
        </div>

        <div class="col-xl-6 md:d-none">
          <p
            v-for="(item, index) in items"
            :key="index"
            :style="`color: var(--c-${vars.textColor}) !important;`"
            class="tw-mb-2"
          >
            {{ item.description }}
          </p>
        </div>
      </div>

      <div
        class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
        data-anim="slide-left delay-1"
        data-gap="30"
        data-slider-cols="xl-3 lg-2 md-1 sm-1 base-1"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide tw-border-2 tw-p-2 lg:!tw-h-full" v-for="(card, index) in cards" :key="index">
            <nuxt-link
              :to="card.button_link"
              :external="true"
              class="imageCard type-2 hover-btn-explore n-link tw-group tw-flex !tw-h-full tw-flex-col md:tw-min-h-[600px]"
            >
              <div class="tw-mb-4 tw-overflow-hidden">
                <library-image
                  :src="card.photo"
                  alt="image"
                  image-class="tw-h-full group-hover:tw-scale-110 tw-transition-all tw-duration-500 tw-w-full tw-object-cover"
                />
              </div>

              <div class="tw-mt-2 tw-flex tw-h-full tw-flex-1 tw-flex-col">
                <h6
                  class="imageCard__title text-dark-1 tw-mb-7 tw-line-clamp-1"
                  :style="`color: var(--${vars.textColor}) !important;`"
                >
                  <b>{{ card.title }}</b>
                </h6>
                <p
                  class="imageCard__text text-dark-1 tw-mb-2 tw-flex-1"
                  :style="`color: var(--${vars.textColor}) !important;`"
                >
                  {{ card.description }}
                </p>

                <button :class="`n-${card.button_type}`" class="tw-mt-auto">
                  {{ card.button_label }}
                </button>
              </div>
            </nuxt-link>
          </div>
        </div>

        <div class="mt-60 md:mt-30 tw-flex tw-items-center tw-justify-center xl:tw-hidden">
          <button class="sliderNav -prev js-prev">
            <i class="icon-left-arrow"></i>
          </button>
          <button class="sliderNav -next ml-20 js-next">
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    v-else-if="variants.v2 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row justify-between items-center">
        <div class="col-auto">
          <div v-html="vars.titleHtml"></div>
        </div>

        <div class="col-xl-6 md:d-none">
          <p :style="`color: var(--${vars.textColor}) !important;`">
            {{ vars.descriptionText }}
          </p>
        </div>
      </div>

      <div
        class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
        data-anim="slide-left delay-1"
        data-gap="30"
        data-slider-cols="xl-2 lg-2 md-1 sm-1 base-1"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide xl-6 tw-border-2 tw-p-2" v-for="(card, index) in cards" :key="index">
            <nuxt-link
              :to="card.link"
              :external="true"
              class="imageCard type-2 hover-btn-explore n-link tw-flex tw-flex-col md:tw-min-h-[600px]"
            >
              <div class="tw-mb-4">
                <library-image :src="card.photo" alt="image" image-class="tw-h-full tw-w-full tw-object-cover" />
              </div>

              <div class="tw-flex tw-flex-1 tw-flex-col">
                <h6
                  class="imageCard__title text-dark-1 tw-line-clamp-1"
                  :style="`color: var(--${vars.textColor}) !important;`"
                >
                  <b>{{ card.title }}</b>
                </h6>
                <p
                  class="imageCard__text text-dark-1 tw-mb-4 tw-mt-4 tw-flex-1"
                  :style="`color: var(--${vars.textColor}) !important;`"
                >
                  {{ card.description }}
                </p>

                <!-- Butonu tam genişlikten çıkartıp, içerik kadar sabitlemek için tw-max-w-max ve tw-self-start ekledik -->
                <button :class="`n-${card.button_type} tw-max-w-max tw-self-start`" class="tw-mt-auto">
                  {{ card.button_label }}
                </button>
              </div>
            </nuxt-link>
          </div>
        </div>

        <div class="mt-60 md:mt-30 tw-flex tw-items-center tw-justify-center lg:tw-hidden">
          <button class="sliderNav -prev js-prev n-link !tw-bg-transparent" style="border-color: #ef787c !important">
            <i class="icon-left-arrow"></i>
          </button>
          <button
            style="border-color: #ef787c !important"
            class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent"
          >
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  name: 'Theme7OurValuations',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
    items() {
      return this.groupedVariables.items;
    },
  },
});
</script>
